if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"campaign_engine_remote","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^((33|92|93)1|449|862)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}